export default (fieldValue,fieldName,label,length) => {
      return {
      valid: (!fieldValue || !isNaN(fieldValue) &&  fieldValue.length > length-1),
      validationText: " חובה להזין ערך מעל ל"+length+" תוים"
    };
  };